<template>
  <div class="animated fadeIn">
    <h4 class="page-title">Partner User Accounts</h4>
    <hr />
    <div class="row">
      <div class="col">
        <div style="margin: 0 auto; width: 10px;" v-if="isFetching">
          <div class="loader-dark-blue medium mb-5 mt-5"></div>
        </div>
        <div class="mb-5" v-show="!isFetching">
          <span v-show="userAccounts.length">Number of data found: <b-badge pill variant="primary">{{userAccounts.length}}</b-badge></span>
          <b-btn class="float-right" variant="primary" size="sm" @click="add()" v-show="!isFetching"><i class="fa fa-plus"></i> Add</b-btn>
        </div>
        <b-alert variant="danger"
          class="text-center"
          :show="!isFetching && !userAccounts.length">
          Data is empty
        </b-alert>
        <b-table responsive hover striped :fields="fields" :items="userAccounts" :per-page="itemsPerPage" :current-page="currentPage" v-show="!isFetching && userAccounts.length">
          <template v-slot:cell(ROLE)="row">
            <span>{{getRoleName(row.item.USER_ROLE_CODE)}}</span>
          </template>
          <template v-slot:cell(PARTNER_API_KEY)="row">
            {{row.value}}
            <!-- <b-btn v-if="row.value" size="sm" variant="outline-info">Show</b-btn> -->
          </template>
          <template v-slot:cell(STATUS)="row">
            <span class="badge badge-sm" v-bind:class="{'badge-success': row.value, 'badge-danger': !row.value}">{{row.value ? 'ACTIVE' : 'INACTIVE'}}</span>
          </template>
          <template v-slot:cell(ACTIONS)="row">
            <b-btn variant="warning" size="sm" @click="edit(row.item)" v-b-tooltip.hover title="Edit account">
              <i class="fa fa-pencil-square-o"></i>
            </b-btn>
            <b-btn class="ml-2" variant="info" size="sm" @click="viewProfile(row.item)" v-b-tooltip.hover title="View profile">
              <i class="fa fa-eye"></i>
            </b-btn>
            <!-- <b-btn v-show="row.item.STATUS < 1" class="ml-2" variant="success" size="sm" @click="activateAccount(row.item)" v-b-tooltip.hover title="Activate account">
              <i class="fa fa-check"></i>
            </b-btn> -->
          </template>
        </b-table>
        <b-pagination v-show="userAccounts.length > 10" :total-rows="userAccounts.length" :per-page="itemsPerPage" v-model="currentPage" />
      </div>
    </div>
  </div>
</template>
<script>
import { server, fieldsService } from '@/services/'
import { PartnerAccountsModal, UserProfilesModal, ActivateAccountModal } from '@/components/modals/'
import { mapState, mapActions, mapGetters } from 'vuex'

export default {
  name: 'user-accounts',
  data () {
    return {
      errorMsg: Object,
      itemsPerPage: 10,
      currentPage: 1,
      itemsCount: 0,
      fields: fieldsService.USER_ACCOUNTS_PARTNER
    }
  },
  methods: {
    loadUserAccounts () {
      this.isFetching = true
      server.get('/getUA').then(
        (resp) => {
          this.isFetching = false
          this.items = resp.data.msgContent.data
          this.itemsCount = resp.data.msgContent.count
        },
        (err) => {
          this.error = err.response
        }
      )
    },
    add () {
      this.$modal.show(PartnerAccountsModal, {mode: 'Add'}, {height: 'auto', scrollable: true})
    },
    edit (obj) {
      this.$modal.show(PartnerAccountsModal, {mode: 'Edit', model: obj}, {height: 'auto', scrollable: true})
    },
    viewProfile (obj) {
      this.$modal.show(UserProfilesModal, {model: obj, caller: 'userAccount'}, {height: 'auto'})
    },
    activateAccount(account) {
      this.$modal.show(ActivateAccountModal, {model: account}, {height: 'auto'})
    }
  },
  created () {
    this.$store.commit('userAccount/setIsFetching', true)
    Promise.all([
      this.$store.cache.dispatch('userService/getAll'),
      this.$store.cache.dispatch('userProfile/getAll'),
      this.$store.cache.dispatch('userRole/getAll'),
      this.$store.cache.dispatch('userAccount/getAllPartner')
    ]).then(
      resp => {
        this.$store.commit('userAccount/setIsFetching', false)
      }
    )
  },
  computed: {
    ...mapState('userAccount', {
      userAccounts: state => state.partners,
      isFetching: state => state.isFetching
    }),
    ...mapState('userService', {
      userServices: state => state.items
    }),
    ...mapState('userProfile', {
      userProfiles: state => state.items
    }),
    ...mapState('userRole', {
      userRoles: state => state.items
    }),
    ...mapGetters('userService', [
      'getUserService'
    ]),
    ...mapGetters('userRole', [
      'getRoleName'
    ])
  }
}
</script>
